export default "__VITE_ASSET__abafbb3a__"